import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectUserType } from '../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../utils/authorization'
import EarningBreakdownTrend from '../../common/earningBreakdown/Trend'
import {
  getNoDataComponent,
  getValueAndTitleCheckbox,
  handleIconDownload,
} from '../../helper'
import { changeChecked, selectChecked } from '../../store/slice'
import { selectDataViewByTrend, selectIndicatorById } from './store/slice'

export const Trend = ({ id, isDynamicReport, check, isDownloadComponent }) => {
  const dispatch = useDispatch()

  const userType = useSelector(selectUserType)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))

  const checked = checkedStore || check

  const setChecked = (checked) => dispatch(changeChecked({ id, checked }))

  const checkboxs = [
    {
      ...getValueAndTitleCheckbox(indicatorById, 'IS27'),
      color: '#006AA6',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'IS30'),
      color: '#74B49A',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA059'),
      color: '#B3CC85',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'IS39'),
      color: '#F49966',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'IS41'),
      color: '#F5CBA3',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'IS16'),
      color: '#D4A7D7',
      group: 3,
    },
  ]

  const isNoData = !dataByTrend?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  return (
    <EarningBreakdownTrend
      id={id}
      data={dataByTrend}
      indicatorById={indicatorById}
      isCheckbox={userType?.userTypeId === USER_TYPE.PREMIUM}
      checkboxs={checkboxs.filter((item) => item.title)}
      checked={checked}
      setChecked={setChecked}
      isDynamicReport={isDynamicReport || isDownloadComponent}
    />
  )
}
